module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/umbrella-449213ec1f6409cdeaa7716e9164d78f.svg";